import ActionName from '@/enums/action-name';
import { AsaPrivilege } from '@/enums/api/attribute-store-adapter/asa-privilege';
import RouteName from '@/enums/route-name';
import { RoleProtectedFeature } from '@/types/feature-names';

const REQUIRED_PRIVILEGES: Record<RoleProtectedFeature, AsaPrivilege[]> = {
    [RouteName.CREATE_SHIPMENT]: [AsaPrivilege.CREATE_SHIPMENT],
    [RouteName.SHIPMENT_ORDER]: [AsaPrivilege.CREATE_SHIPMENT],
    [RouteName.PARCEL_DATA]: [AsaPrivilege.PARCEL_DATA],
    [RouteName.PARCEL_TRACKING]: [AsaPrivilege.PARCEL_TRACKING_PARTNER, AsaPrivilege.PARCEL_TRACKING_CUSTOMER],
    [RouteName.REVERT]: [AsaPrivilege.REVERT_PARCEL],
    [RouteName.REPRINT]: [AsaPrivilege.REPRINT_LABEL],
    [RouteName.FORWARD]: [AsaPrivilege.FORWARD_PARCEL],
    [RouteName.INITIAL]: [AsaPrivilege.INITIAL_PARCEL],
    [RouteName.SHIPMENT_OVERVIEW]: [AsaPrivilege.SHIPMENT_OVERVIEW],
    [RouteName.TRANSPORTATION_LIST_CREATE]: [AsaPrivilege.CREATE_TRANSPORTATION_LIST],
    [RouteName.TRANSPORTATION_OVERVIEW]: [AsaPrivilege.TRANSPORTATION_OVERVIEW],
    [RouteName.PARCEL_AUTO_ASSIGNMENT]: [AsaPrivilege.AUTO_PARCELS_ASSIGNMENT],
    [RouteName.ASSIGN_PARCELS_TO_LOADING_LIST]: [AsaPrivilege.LOADING_LIST_ASSIGNMENT],
    [RouteName.PARCEL_STATUS_ASSIGNMENT]: [AsaPrivilege.TRACKING_INPUT], // TODO to be verified
    [RouteName.MT_WEIGHING_SCALE_TESTING]: [], // TODO to be removed
    [ActionName.TRANSPORTATION_STATUS_UPDATE]: [AsaPrivilege.TRANSPORTATION_STATUS_UPDATE],
    [ActionName.TRANSPORTATION_PARCELS_PREVIEW]: [AsaPrivilege.TRANSPORTATION_PARCELS_PREVIEW],
    [ActionName.TRANSPORTATION_LOAD_UNITS_PREVIEW]: [AsaPrivilege.TRANSPORTATION_OVERVIEW],
    [ActionName.PARCEL_TRACKING_INPUT]: [AsaPrivilege.TRACKING_INPUT]
};

export { REQUIRED_PRIVILEGES };
